export const TRANSLATIONS_EN = {
  "One link for everything you make, share and sell — free, no paywall on the core tools.": "One link for everything you make, share and sell — free, no paywall on the core tools.",
  "Footer navigation": "Footer navigation",
  "Explore": "Explore",
  "Home": "Home",
  "About": "About",
  "QR Code Generator": "QR Code Generator",
  "Contact": "Contact",
  "Get in touch": "Get in touch",
  "All rights reserved.": "All rights reserved.",
  "Crop photo": "Crop photo",
  "Drag to reposition, pinch or use the slider to zoom": "Drag to reposition, pinch or use the slider to zoom",
  "Close": "Close",
  "This image could not be opened": "This image could not be opened",
  "Zoom out": "Zoom out",
  "Zoom": "Zoom",
  "Zoom in": "Zoom in",
  "Reset": "Reset",
  "Cancel": "Cancel",
  "Saving...": "Saving...",
  "Apply": "Apply",
  "Change language": "Change language",
  "Main navigation": "Main navigation",
  "Logout": "Logout",
  "Login": "Login",
  "Open menu": "Open menu",
  "Close menu": "Close menu",
  "Language": "Language",
  "QR Generator": "QR Generator",
  "Download": "Download",
  "About Linkakam": "About Linkakam",
  "A link in bio tool that doesn't paywall the basics.": "A link in bio tool that doesn't paywall the basics.",
  "Linkakam started from a simple frustration: the tools creators need most — a clean link page, a working contact form, real analytics — are usually the first things locked behind a subscription. We built Linkakam the other way around.": "Linkakam started from a simple frustration: the tools creators need most — a clean link page, a working contact form, real analytics — are usually the first things locked behind a subscription. We built Linkakam the other way around.",
  "“We'd rather earn trust by being useful for free than earn revenue by holding features back.”": "“We'd rather earn trust by being useful for free than earn revenue by holding features back.”",
  "Build your page in a few minutes.": "Build your page in a few minutes.",
  "No credit card. No trial countdown. Just your links, live.": "No credit card. No trial countdown. Just your links, live.",
  "Create your link": "Create your link",
  "Free means free": "Free means free",
  "Your link page, forms and analytics stay free as your audience grows. No feature paywall waiting for you at 1,000 followers.": "Your link page, forms and analytics stay free as your audience grows. No feature paywall waiting for you at 1,000 followers.",
  "Built for creators first": "Built for creators first",
  "Every tool we ship — link pages, QR codes, CVs, storefronts — starts from what people actually build with their bio link, not what upsells well.": "Every tool we ship — link pages, QR codes, CVs, storefronts — starts from what people actually build with their bio link, not what upsells well.",
  "One link, fully yours": "One link, fully yours",
  "Your profile, your links, your data. Export it, move it, or take it down whenever you want.": "Your profile, your links, your data. Export it, move it, or take it down whenever you want.",
  "Talk to us": "Talk to us",
  "Questions, feedback, or a bug to report — we read every message.": "Questions, feedback, or a bug to report — we read every message.",
  "Email": "Email",
  "Phone": "Phone",
  "Name": "Name",
  "Subject": "Subject",
  "Message": "Message",
  "Sending...": "Sending...",
  "Send message": "Send message",
  "Message sent — we'll get back to you soon.": "Message sent — we'll get back to you soon.",
  "Something went wrong sending your message. Please email us directly at support@linkakam.com.": "Something went wrong sending your message. Please email us directly at support@linkakam.com.",
  "Everything you make,": "Everything you make,",
  "one link away.": "one link away.",
  "Create a single, shareable link for all your social profiles, business pages, product catalogs and menus — with built-in forms, analytics and QR codes, free.": "Create a single, shareable link for all your social profiles, business pages, product catalogs and menus — with built-in forms, analytics and QR codes, free.",
  "See how it works": "See how it works",
  "Search For Profile": "Search For Profile",
  "Search": "Search",
  "A Linkakam profile page on a phone": "A Linkakam profile page on a phone",
  "Profile visits": "Profile visits",
  "Scan to share": "Scan to share",
  "How it works": "How it works",
  "Back to home": "Back to home",
  "Search results": "Search results",
  "Searching...": "Searching...",
  "profile": "profile",
  "profiles": "profiles",
  "for": "for",
  "No profiles found": "No profiles found",
  "Check the spelling or try a different username.": "Check the spelling or try a different username.",
  "Add all your links": "Add all your links",
  "Connect your socials, store, videos, music, podcast and events. It all comes together on one page designed to convert.": "Connect your socials, store, videos, music, podcast and events. It all comes together on one page designed to convert.",
  "Help your followers": "Help your followers",
  "Help your followers discover everything you're sharing all over the internet, in one simple place. They'll thank you for it.": "Help your followers discover everything you're sharing all over the internet, in one simple place. They'll thank you for it.",
  "Share it everywhere": "Share it everywhere",
  "Add your unique Linkakam URL to every platform your audience is on, then use your QR code to bring offline traffic online.": "Add your unique Linkakam URL to every platform your audience is on, then use your QR code to bring offline traffic online.",
  "Something went wrong. Please try again.": "Something went wrong. Please try again.",
  "Invalid username or password": "Invalid username or password",
  "The link was sent to your email": "The link was sent to your email",
  "check your email": "check your email",
  "Oops...": "Oops...",
  "Email not found": "Email not found",
  "Username cannot contain spaces": "Username cannot contain spaces",
  "Please enter your email first": "Please enter your email first",
  "An error occurred": "An error occurred",
  "Please enter the code sent to your email": "Please enter the code sent to your email",
  "Passwords do not match": "Passwords do not match",
  "Please verify your email before submitting": "Please verify your email before submitting",
  "All your links, in one place": "All your links, in one place",
  "Register": "Register",
  "Please Log In": "Please Log In",
  "Username": "Username",
  "Password": "Password",
  "Remember me": "Remember me",
  "Forgot your password?": "Forgot your password?",
  "Submit": "Submit",
  "Don't have an account?": "Don't have an account?",
  "Register Please": "Register Please",
  "User Name": "User Name",
  "email": "email",
  "Verified": "Verified",
  "Resend": "Resend",
  "Verify": "Verify",
  "Enter the 6-digit code": "Enter the 6-digit code",
  "Checking...": "Checking...",
  "Confirm": "Confirm",
  "Confirm Password": "Confirm Password",
  "Already have an account?": "Already have an account?",
  "Reset password": "Reset password",
  "Enter your email and you will receive a reset password link": "Enter your email and you will receive a reset password link",
  "Verify your email": "Verify your email",
  "We sent a 6-digit code to": "We sent a 6-digit code to",
  "Verification code": "Verification code",
  "Code expires in": "Code expires in",
  "Code expired": "Code expired",
  "Resend code": "Resend code",
  "Back to login": "Back to login",
  "Paste a link or type text first": "Paste a link or type text first",
  "Couldn't generate that QR code, try a shorter link": "Couldn't generate that QR code, try a shorter link",
  "Tool": "Tool",
  "Generate your QR code": "Generate your QR code",
  "Turn your Linkakam profile or any link into a QR code you can print, share and download.": "Turn your Linkakam profile or any link into a QR code you can print, share and download.",
  "Link or text": "Link or text",
  "Use my profile link": "Use my profile link",
  "QR code type": "QR code type",
  "Link / Text": "Link / Text",
  "Wi-Fi": "Wi-Fi",
  "WPA/WPA2": "WPA/WPA2",
  "WEP": "WEP",
  "None": "None",
  "Network name (SSID)": "Network name (SSID)",
  "Security": "Security",
  "Show": "Show",
  "Hide": "Hide",
  "Hidden network": "Hidden network",
  "Enter the network name": "Enter the network name",
  "Enter the Wi-Fi password": "Enter the Wi-Fi password",
  "Foreground color": "Foreground color",
  "Background color": "Background color",
  "Add Linkakam logo to the center": "Add Linkakam logo to the center",
  "Generating...": "Generating...",
  "Generate": "Generate",
  "Your QR code will appear here.": "Your QR code will appear here.",
  "Download PNG": "Download PNG",
  "Download SVG": "Download SVG",
  "Ink": "Ink",
  "Brand blue": "Brand blue",
  "Accent pink": "Accent pink",
  "White": "White",
  "Soft grey": "Soft grey",
  "Cover": "Cover",
  "Change cover": "Change cover",
  "Remove background": "Remove background",
  "Image": "Image",
  "Link Title": "Link Title",
  "Link": "Link",
  "Avatar": "Avatar",
  "link titel": "link titel",
  "iPhone preview frame": "iPhone preview frame",
  "Please wait for the image to finish uploading": "Please wait for the image to finish uploading",
  "Make sure you fill in all the fields": "Make sure you fill in all the fields",
  "Could not save theme": "Could not save theme",
  "Please choose an image file": "Please choose an image file",
  "Crop cover": "Crop cover",
  "Crop image": "Crop image",
  "Loading": "Loading",
  "Bio": "Bio",
  "Theme": "Theme",
  "select": "select",
  "Website": "Website",
  "Call": "Call",
  "Other": "Other",
  "Add": "Add",
  "Add image": "Add image",
  "View as visitor": "View as visitor",
  "Share": "Share",
  "Live preview · updates as you type": "Live preview · updates as you type",
  "Preview": "Preview",
  "Profile preview": "Profile preview",
  "Share profile": "Share profile",
  "Share your profile link or QR code": "Share your profile link or QR code",
  "copy": "copy",
  "copied": "copied",
  "No links yet.": "No links yet.",
  "Powered by Linkakam": "Powered by Linkakam",
  "Back": "Back",
  "Copy profile link": "Copy profile link",
  "Copied": "Copied",
  "Copy link": "Copy link",
  "Mobile": "Mobile",
  "Tablet": "Tablet",
  "Desktop": "Desktop",
  "Please choose a JPG, PNG or WebP image": "Please choose a JPG, PNG or WebP image",
  "Image must be 5 MB or smaller": "Image must be 5 MB or smaller",
  "Something went wrong": "Something went wrong",
  "Network error, please try again": "Network error, please try again",
  "Statistics": "Statistics",
  "Page statistics": "Page statistics",
  "Back to my page": "Back to my page",
  "See how many people have visited your page.": "See how many people have visited your page.",
  "Total visits": "Total visits",
  "Last 7 days": "Last 7 days",
  "Last 30 days": "Last 30 days",
  "This month": "This month",
  "No visits last month": "No visits last month",
  "vs last month": "vs last month",
  "No visits yet": "No visits yet",
  "Share your page link to start seeing visits here.": "Share your page link to start seeing visits here.",
  "Visits per month": "Visits per month",
  "Last 12 months": "Last 12 months",
  "Best month": "Best month",
  "Monthly average": "Monthly average",
  "Visits today": "Visits today",
  "Daily visits": "Daily visits",
  "My page": "My page",
  "Link copied": "Link copied",
  "Account menu": "Account menu"
};
